var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".social-facebook_svg__st0,.social-facebook_svg__st1{fill:#231f20}.social-facebook_svg__st1,.social-facebook_svg__st2{fill-rule:evenodd;clip-rule:evenodd}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social-facebook_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8 33.2v5.6h8.6l-1.1 10.1h-7.5v28H42.9v-28h-5.4V38.8h5.4v-5.6s-1-10.7 8.6-12.3h11.8v9H58s-3.1-.1-3.2 3.3z",
    id: "social-facebook_svg__facebook"
  }))));
};
export default SvgSocialFacebook;